// extracted by mini-css-extract-plugin
module.exports = {"paymentPlanList":"PaymentPlanForm_paymentPlanList__NIxW4","saveButton":"PaymentPlanForm_saveButton__2AxfL","label":"PaymentPlanForm_label__1ttCc"};